/**
 * pagination
 * 从酷校前端迁移的分页组件
 *
 * Modified by ph2 on 2017/02/10
 *      增加 syncId 参数，相同 syncId 的实例之间自动同步状态
 *          （相同 syncId 的不同实例的 pageargs 使用不同的变量绑定；pagefn 其中一个实例拥有实际逻辑，其他为空函数或null）
 *      移除 deepwatch 配置，不支持深度监听
 *      ps: 原本写的非常恶心。。
 * Modified by ph2 on 2017/02/10
 *      移除 list 参数
 */

;(function () {

    paginationCtrl.$inject = ['$scope', 'paginationService'];
    angular.module('app.core')
        .directive("pagination", function () {
            return {
                template:'<div class="page-bar"><a href="javascript:;" ng-class="{disabled:current<=0}" ng-click="prev()"><em class="emic">&lt;</em><em class="emf">上一页</em></a> <a href="javascript:;" ng-repeat="key in keyList" ng-class="{cur:key==current}" ng-click="jump(key)" ng-bind="(key+1)"></a> <span ng-show="pLen>pMax && !hideEllipsis">...</span> <a href="javascript:;" ng-class="{disabled:current>=pLen-1}" ng-click="next()"><em class="emf">下一页</em><em class="emic">&gt;</em></a> <span class="jump-bar"><span>共<font class="blue-c" ng-bind="pLen"></font>页</span> <span>跳到 <input type="text" style="width:38px;height:19px;text-align:center;" ng-model="goKey"> 页</span> <a href="javascript:;" ng-click="go(goKey)">确定</a></span> <span class="jump-eng"><span>Go to Page <input type="text" style="width:38px;height:19px;text-align:center;" ng-model="goKey"></span> <a href="javascript:;" ng-click="go(goKey)">Go</a></span><div class="mini"><i class="left" ng-class="{disabled:current<=0}" ng-click="prev()"></i> <span>{{current + 1}}/{{pLen}}</span> <i class="right" ng-class="{disabled:current>=pLen-1}" ng-click="next()"></i></div><div class="icon-mini"><button class="p-btn p-btn-normal icon-btn" ng-class="{disabled:current<=0}" ng-click="prev()"><i class="iconfont icon-back"></i></button><div class="page-count"><span class="cur">{{current + 1}}</span><span>/{{pLen}}</span></div><button class="p-btn p-btn-normal icon-btn" ng-class="{disabled:current>=pLen-1}" ng-click="next()"><i class="iconfont icon-more"></i></button></div></div>',
                restrict: "E",
                replace: true,
                scope: {
                    syncId: '<',
                    pagefn: "=pagefn",
                    pageargs: "=pageargs",
                },
                controller: paginationCtrl,
            };
        })
        .service('paginationService', paginationService)
    ;

    function paginationCtrl($scope, paginationService) {
        var vm = $scope
            , paginationId = $scope.$id
        ;

        vm.pageargs = vm.pageargs || null; // 该行代码意义仅为 vm.pageargs.xx = xx 赋值语句时 WebStorm 不报警告


        function init() {
            console.log('[pagination] syncId: ', vm.syncId);

            //监听页码数据
            $scope.$watch('pageargs', paginationDataOnChange);

            // 与其他实例同步状态
            if (vm.syncId) {
                paginationService.registerSyncLock(paginationId, vm.syncId, paginationSyncLockCallBack);

                $scope.$on('$destroy', function () {
                    paginationService.deregisterSyncLock(paginationId)
                });
            }
        }

        // 分页参数 OnChange
        function paginationDataOnChange(newValue, last) {
            if (newValue) {
                if (true === newValue._omitChange) {
                    delete newValue._omitChange
                    return;
                }

                resolvePageArguments(vm.pageargs);
                callPageFn(vm.pageargs);
                vm.syncId && paginationService.updateSyncLockData(paginationId, {pageargs: vm.pageargs});
            }
        }

        // 分页 total OnChange
        function paginationPageAmountOnChange(pageAmountData) {
            var amount = pageAmountData && pageAmountData.pa && pageAmountData.pa.total;
            calcPaginationPage(pageAmountData && pageAmountData.pa && pageAmountData.pa.total);
            vm.syncId && paginationService.updateSyncLockData(paginationId, {pageAmount: amount});
        }

        // 由其他相同 syncId 的实例触发的数据更新
        function paginationSyncLockCallBack(data) {
            data = data || {}

            if (data.pageargs) {
                var t_args = {
                        pn: data.pageargs.pn,
                        ps: data.pageargs.ps,
                        pl: data.pageargs.pl,
                    }
                ;

                if (vm.pageargs) {
                    angular.extend(vm.pageargs, t_args);
                } else {
                    t_args._omitChange = true;
                    vm.pageargs = t_args;
                }

                resolvePageArguments(vm.pageargs);
                callPageFn(vm.pageargs);
            }

            if ('number' === typeof data.pageAmount) {
                calcPaginationPage(data.pageAmount);
            }
        }

        // resolve page arguments
        function resolvePageArguments(pageArgs) {
            vm.current = parseInt(pageArgs.pn) - 1;
            vm.pageNode = vm.current;
            vm.pNum = parseInt(pageArgs.ps);
            vm.pMax = parseInt(pageArgs.pl) || 5;
        }

        /**
         * 计算显示页码
         * @param  {Number} argTotal
         */
        function calcPaginationPage(argTotal) {
            //计算总页数
            vm.pLen = Math.ceil(argTotal / vm.pNum);
            var pLen = vm.pLen;
            if (pLen > vm.pMax) {
                var half = Math.ceil(vm.pMax / 2);
                var cur = vm.current;
                if (cur >= half && cur < (pLen - (vm.pMax - half))) {
                    renderKeyList((cur - (vm.pMax - half)), (cur + half), pLen);
                } else if (cur >= (pLen - (vm.pMax - half))) {
                    renderKeyList((pLen - vm.pMax), pLen, pLen);
                } else if (cur <= half) {
                    renderKeyList(0, pLen, vm.pMax);
                }
            } else {
                renderKeyList(0, pLen, vm.pMax);
            }
        }


        /**
         * 显示页面码列表
         * @param  {Number} s
         * @param  {Number} e
         * @param  {Number} limit
         */
        function renderKeyList(s, e, limit) {
            vm.keyList = [];
            for (var i = s; i < e; i++) {
                if (i >= limit) {
                    break;
                }
                vm.hideEllipsis = (i + 1 === vm.pLen);
                vm.keyList.push(i);
            }
        }

        /**
         * 调用分页回调
         * @param {{pn: Number, ps: Number, pl:Number}} pageArgs
         */
        function callPageFn(pageArgs) {
            try {
                vm.pagefn && vm.pagefn(pageArgs, paginationPageAmountOnChange);
            } catch (e) {
                console.log('[pagination] pagefn callback Uncaught exception:', e);
            }
        }

        /**
         * 跳页码
         * @param  {Number} key
         */
        vm.jump = function (key) {
            if (vm.pageNode === key) {
                return;
            }
            vm.current = key;
            vm.pageNode = key;
            vm.pageargs.pn = key + 1;
            callPageFn(vm.pageargs);
            vm.syncId && paginationService.updateSyncLockData(paginationId, {pageargs: vm.pageargs});
        };

        /**
         * 下一页
         */
        vm.next = function () {
            vm.current++;
            if (vm.current >= vm.pLen) {
                vm.current = vm.pLen - 1;
            }
            vm.jump(vm.current);
        };

        /**
         * 上一页
         */
        vm.prev = function () {
            vm.current--;
            if (vm.current <= 0) {
                vm.current = 0;
            }
            vm.jump(vm.current);
        };

        /**
         * 跳指定页面
         * @param  {Number|String} key
         */
        vm.go = function (key) {
            var regNum = /^-?\d+$/g;
            if (key === undefined || key.length <= 0) {
                // service.dialog.alert('输入不能为空！', {});
            } else if (regNum.test(key)) {
                if (parseInt(key) > vm.pLen) {
                    key = vm.pLen;
                    // service.dialog.alert('总共只有' + vm.pLen + '页，为您转到最后一页！', {});
                } else if (parseInt(key) <= 0) {
                    key = 1;
                    // service.dialog.alert('不能低于第1页,为您转到最前一页！', {});
                }
                vm.jump((parseInt(key) - 1));
                vm.goKey = undefined;
            } else if (key.match(/\s+/g)) {
                // service.dialog.alert('输入不能有空格符！', {});
            } else {
                // service.dialog.alert('格式错误，请输入整数！', {});
            }
        };

        init();
    }

    function paginationService() {
        var instances = {}
            , syncGroups = {};

        this.registerSyncLock = registerSyncLock;
        this.deregisterSyncLock = deregisterSyncLock;
        this.updateSyncLockData = updateSyncLockData;


        function registerSyncLock(paginationId, syncId, syncCallBack) {
            if (!(paginationId && syncId && 'function' === typeof syncCallBack)) {
                throw new Error('[paginationService] registerSyncLock\'s parameter is incorrect');
            }

            var ins, group;

            ins = instances[paginationId];

            if (!ins) {
                ins = instances[paginationId] = {syncId: syncId, syncCallBack: syncCallBack};
            } else {
                console.warn('[paginationService] registerSyncLock: Repeat registration is not allowed [paginationId:%s, syncId:%s]', paginationId, syncId);
            }

            group = syncGroups[syncId];
            if (!group) {
                group = syncGroups[syncId] = {
                    // pagination id list
                    pids: [],
                };
            }

            group.pids.push(paginationId);
        }

        function deregisterSyncLock(paginationId) {
            var ins, group, idx;

            ins = instances[paginationId];
            if (!ins) {
                return;
            }
            delete instances[paginationId];

            group = syncGroups[ins.syncId];
            if (!(group && group.pids && group.pids.length)) {
                return;
            }

            idx = group.pids.indexOf(paginationId);
            if (idx === -1) {
                return;
            }

            if (group.pids.length === 1) {
                delete syncGroups[ins.syncId];
            } else {
                group.pids.splice(idx, 1);
            }
        }

        function updateSyncLockData(paginationId, data) {
            var ins, group;

            ins = instances[paginationId];
            if (!ins) {
                return;
            }

            group = syncGroups[ins.syncId];
            if (!(group && group.pids && group.pids.length)) {
                return;
            }

            group.pids.forEach(function (pid) {
                if (pid === paginationId) {
                    return;
                }
                var pa = instances[pid];
                pa && pa.syncCallBack && pa.syncCallBack(data);
            })
        }

    }


})();
